import config from '../config';
import { request } from '../utils/request';

const menuDomain = `${config.host}${config.apiRouter.menu}`;

const api = {
  get (data) {
    return request.post(`${menuDomain}/GetMenu`, data);
  },
};
export default api;
